.primary {
  background: #ffb703; /* onboarding yellow */
  color: #000000;
  border: none;
  padding: 16px 20px;
  border-radius: 8px;
  font-family: 'Poppins', sans-serif;
  font-weight: 600;
  font-size: 16px;
  cursor: pointer;
  white-space: nowrap;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  gap: 8px;
  min-height: 56px;
}

.secondary {
  background: #04051b; /* dark navy */
  color: #ffffff;
  border: none;
  padding: 16px 20px;
  border-radius: 14px;
  font-family: 'Poppins', sans-serif;
  font-weight: 500;
  font-size: 16px;
  cursor: pointer;
  white-space: nowrap;
  display: flex;
  justify-content: center;
  align-items: center;
}

.light {
  background: #ffffff;
  border: 1px solid #fbca74;
  color: #04051b;
  padding: 16px 20px;
  border-radius: 14px;
  font-family: 'Poppins', sans-serif;
  font-weight: 500;
  font-size: 16px;
  cursor: pointer;
  white-space: nowrap;
  display: flex;
  justify-content: center;
  align-items: center;
}

.outline {
  background: transparent;
  border: 1px solid #e8f6fc;
  color: #ffffff;
  padding: 8px;
  cursor: pointer;
  white-space: nowrap;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 6px;
  cursor: pointer;
}

.iconLeft {
  width: 24px;
  height: auto;
  margin-right: 8px;
}

.primary,
.secondary,
.light {
  transition:
    transform 0.12s ease,
    box-shadow 0.12s ease,
    background-color 0.15s ease;
}

.primary:hover,
.secondary:hover,
.light:hover {
  transform: translateY(-1px);
  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.12);
}

.primary:active,
.secondary:active,
.light:active {
  transform: translateY(0);
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.18);
}

.primary:focus-visible,
.secondary:focus-visible,
.light:focus-visible {
  outline: none;
  box-shadow: 0 0 0 3px rgba(255, 161, 0, 0.4);
}

.outline:disabled {
  border: 1px solid rgba(232, 246, 252, 0.15);
  color: rgba(255, 255, 255, 0.45);
  opacity: 0.6;
  cursor: not-allowed;
}

.primary:disabled,
.secondary:disabled,
.light:disabled {
  opacity: 0.6;
  cursor: not-allowed;
  transform: none;
  box-shadow: none;
}

.outline:disabled img {
  opacity: 0.15;
}

.primary:disabled:hover,
.secondary:disabled:hover,
.light:disabled:hover {
  transform: none;
  box-shadow: none;
}

.loading {
  position: relative;
  cursor: not-allowed;
  opacity: 0.8;
}

.spinner {
  animation: spin 1s linear infinite;
  flex-shrink: 0;
}

@keyframes spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
